import SelectorEngine from '../../utils/dom/selector-engine';
import Modal from '../../components/Modal';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';
import Request from '../../utils/request';

const CHANGE_EVENT = 'change';
class EditCurrentOfferings {
	constructor() {
		this._container = SelectorEngine.findOne('.js-edit-coach-details-current-offerings');
		this.toggleStatus = undefined;
		this.currentOfferings = [];

		if (this._container) {
			this.init();
		}
	}

	init() {
		this._form = SelectorEngine.findOne('#lta-coach-details__edit-current-offerings-form', this._container);

		this._errorContainer = SelectorEngine.findOne('.lta-coach-details__edit-current-offerings-container', this._form);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});

		this._exitModal = new Modal(SelectorEngine.findOne('#coach-details-current-offerings-exit'), {});

		this._cancelCta = SelectorEngine.findOne('.lta-coach-details__edit-current-offerings-back');
		this._cancelCta.addEventListener('click', () => this._exitModal.show());

		this._saveCta = SelectorEngine.findOne('.lta-coach-details__edit-current-save-btn', this._form);
		this._saveCta.addEventListener('click', (event) => this.submitForm(event));

		const popupCancel = SelectorEngine.findOne('.lta-coach-details__edit-current-offerings-continue');
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.lta-coach-details__edit-current-offerings-exit');
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		const currentOfferings = SelectorEngine.find('input[type="checkbox"]', this._form);
		for (const checkbox of currentOfferings) {
			if (checkbox.checked) {
				this.currentOfferings.push(checkbox.value);
			}
			EventHandler.on(checkbox, CHANGE_EVENT, (event) => {
				this.handleCheckboxClick(event);
			});
		}

		this.toggleButton = SelectorEngine.findOne('.lta-coach-details__edit-current-offerings-toggle', this._container);
		const initialStatus = this.toggleButton.querySelector('.lta-toggle--checkbox').checked;
		this.toggleStatus = initialStatus ? initialStatus : false;

		EventHandler.on(window, 'toggleStatus', (event) => {
			this.toggleStatus = event.detail.status;
		});
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}

	async submitForm(event) {
		event.preventDefault();
		startLoadingAnimation(true);
		const payload = {
			updateCoachDetailsRequest: {
				myCurrentOfferings: {
					currentOfferings: this.currentOfferings,
					currentOfferingsVisibility: this.toggleStatus
				}
			}
		};

		try {
			const url = `/api/coachdetails/update`;
			const responseData = await Request.post(url, payload);

			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this._form, 'redirect-url');
				window.location.href = redirectUrl;
			} else {
				this._errorContainer.classList.remove('u-hidden');
				this._errorText.innerHTML = Manipulator.getDataAttribute(this._form, 'api-failed-error');
			}
		} catch {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this._form, 'api-failed-error');
			this._errorContainer.scrollIntoView();
		} finally {
			stopLoadingAnimation();
		}
	}

	handleCheckboxClick(event) {
		if (event.target.checked) {
			this.currentOfferings.push(event.target.value);
		} else {
			this.currentOfferings = this.currentOfferings.filter((value) => value !== event.target.value);
		}
	}
}

const globalEditCurrentOfferings = new EditCurrentOfferings();

export default globalEditCurrentOfferings;
